import React, { useCallback, useMemo, useState } from 'react';
import {
	Textarea,
	FormItem,
	Button,
	Space,
	Modal,
	Textbox,
	ModalTitle,
} from '@components';
import './AddAgendaItemModal.scss';
import { AgendaItem } from '@api';
import { GUID } from '@common';

interface AddAgendaItemModalProps {
	closeModal: () => void,
	onSubmit: (item: AgendaItem, newItemIndex: number) => void,
	newItemIndex: number,
}

function AddAgendaItemModal(props: AddAgendaItemModalProps): JSX.Element {
	const {
		closeModal,
		onSubmit,
		newItemIndex,
	} = props;

	const [agendaItemText, setAgendaItemText] = useState<string>('');
	const [agendaItemSpeaker, setAgendaItemSpeaker] = useState<string>('');

	const handleSubmit = useCallback((): void => {
		const item = new AgendaItem({
			id: GUID(),
			annotation: null,
			speakers: agendaItemSpeaker ? [agendaItemSpeaker] : [],
			text: agendaItemText
		});
		
		onSubmit(item, newItemIndex);		
		closeModal();

	}, [agendaItemText, agendaItemSpeaker, closeModal, newItemIndex, onSubmit]);

	const headerView = useMemo((): JSX.Element => {
		return (
			<div className="add-agenda-modal__header">
				<ModalTitle onClose={closeModal}>
					Добавление вопроса повестки
				</ModalTitle>
			</div>
		);
	}, [closeModal]);

	const footerView = useMemo(() => {
		return (
			<Space>
			<Button theme="primary" onClick={handleSubmit}>
				Добавить
			</Button>
			<Button onClick={closeModal}>
				Отменить
			</Button>
		</Space>
		);
	}, [handleSubmit, closeModal]);

	return (
		<Modal
			className="add-agenda-modal"
			header={headerView}
			footer={footerView}
			isOpen
		>
			<div className="add-agenda-modal__content">
				<FormItem>
					<Textarea
						autoFocus
						className="add-agenda-modal__textfield"
						value={agendaItemText}
						placeholder="Текст вопроса повестки"
						onValueChange={(val) => setAgendaItemText(val)}
					/>
				</FormItem>
				<FormItem label="Докладчик">
					<Textbox
						value={agendaItemSpeaker}
						onValueChange={(val) => setAgendaItemSpeaker(val)}
					/>
				</FormItem>
			</div>
		</Modal>
	);
}

export {AddAgendaItemModal};